module.exports = __webpack_public_path__ + "static/media/post_add-24px.d9d288d2.svg";